<template>
  <div class="m-0 p-0">
    <b-modal ref="processPaymentModal" body-class="p-0 m-0" hide-footer>
      <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
        <b-form role="form" @submit.prevent="handleSubmit(processPayment)">
          <div class="pr-4 pb-4 pl-4">
            <h3>Process Payment</h3>
            Enter the amount you would like applied to this payment plan
            <br /><br />
            <base-input-currency
              v-model="processPaymentAmount"
              rules="required|money"
              label="Payment Amount"
              name="Amount"
              prependChar="$"
            ></base-input-currency>
            <b-button type="submit" variant="primary">Process Payment</b-button>
          </div>
        </b-form></validation-observer
      >
    </b-modal>

    <b-modal ref="transactionModal" size="xl" body-class="p-0 m-0" hide-footer>
      <transaction-search-results
        :query="transactionQuery"
        supressOptions="true"
      />
    </b-modal>

    <ask
      ref="askToProcessModal"
      :title="processTitle"
      @ok="process"
      :message="processMessage"
    ></ask>

    <ask
      ref="askToCancelModal"
      title="Cancel Payment Plan"
      @ok="changedActive(false)"
      message="Canceled payment plans cannot be re-activated. Are you sure you would like to cancel this payment plan?"
    ></ask>

    <b-row class="m-0">
      <b-col class="modal-hero" style="padding-top: 15px !important;">
        <span class="status-pill status-pill-id">ID {{ paymentPlan.id }}</span>
        <span
          class="status-pill status-pill-active"
          v-if="
            paymentPlan.currentCycle !== 0 && paymentPlan.status == 'ACTIVE'
          "
          >Active</span
        >

        <span
          class="status-pill status-pill-active"
          v-if="paymentPlan.currentCycle == 0 && paymentPlan.status == 'ACTIVE'"
        >
          Starting
          {{ paymentPlan.nextBillingDate | moment("MM/DD/YYYY") }}
        </span>

        <span
          class="status-pill status-pill-inactive"
          v-if="paymentPlan.status == 'INACTIVE'"
          >Canceled {{ paymentPlan.cancelledDate | moment("MM/DD/YYYY") }}
        </span>
        <span
          class="status-pill status-pill-complete"
          v-if="paymentPlan.status == 'COMPLETE'"
          >Completed
          {{ paymentPlan.completedDate | moment("MM/DD/YYYY") }}</span
        >

        <div
          v-if="
            paymentPlan.balancePastDue > 0 && paymentPlan.status == 'ACTIVE'
          "
          class="pb-3"
        >
          <b-row
            class="m-0 mb-2 light-alert light-alert-error"
            align-v="center"
          >
            <b-col class="p-0">
              <i class="fa-solid fa-bell-on"></i>This payment plan has a past
              due balance of
              <strong>{{
                (paymentPlan.balancePastDue / 100) | currency
              }}</strong
              >.
            </b-col>
            <b-col class="p-0 text-right">
              <b-button
                v-if="hasRole('EDITPAYMENTPLANS')"
                variant="danger"
                @click.prevent="
                  askToProcess(
                    'Process Past Due Balance',
                    `Are you sure you would like to process the past due balance of ${$options.filters.currency(
                      paymentPlan.balancePastDue / 100
                    )}?`,
                    paymentPlan.balancePastDue
                  )
                "
                href=""
                >Process Past Due</b-button
              >
            </b-col>
          </b-row>
        </div>

        <b-card class="p-0 m-0 shadow-none">
          <b-row>
            <b-col class="pr-0 panel-divider panel-first">
              <div class="card-panel">
                <div class="stat-box-title">Payment Plan Total</div>
                <div class="stat-box-body">
                  {{ (paymentPlan.paymentPlanTotal / 100) | currency }}<br />
                  <a
                    v-if="
                      paymentPlan.status == 'ACTIVE' &&
                        hasRole('EDITPAYMENTPLANS')
                    "
                    @click.prevent="
                      () => {
                        $refs.askToCancelModal.ask();
                      }
                    "
                    href="#"
                    ><small><strong>Cancel Plan</strong></small></a
                  >
                </div>
              </div>
            </b-col>
            <b-col class="pl-0 pr-0 panel-divider">
              <div class="card-panel">
                <div class="stat-box-title">Processed</div>
                <div class="stat-box-body">
                  {{ (paymentPlan.paidToDate / 100) | currency }}
                </div>
              </div>
            </b-col>
            <b-col
              class="pl-0 pr-0 panel-divider"
              v-if="paymentPlan.status == 'ACTIVE' && nextPaymentPlanDetail"
            >
              <div class="card-panel">
                <div class="stat-box-title">
                  Upcoming Payment
                </div>
                <div class="stat-box-body">
                  {{
                    ((nextPaymentPlanDetail.amountDue +
                      paymentPlan.balancePastDue) /
                      100)
                      | currency
                  }}<br />
                  <small class="text-muted"
                    ><strong
                      >{{
                        nextPaymentPlanDetail.billingDate | moment("MM/DD/YYYY")
                      }}
                    </strong></small
                  >
                </div>
              </div>
            </b-col>

            <b-col class="pl-0 pr-0 panel-divider">
              <div class="card-panel">
                <div class="stat-box-title">Balance</div>
                <div class="stat-box-body">
                  {{ (paymentPlan.balanceDue / 100) | currency }}
                  <template v-if="paymentPlan.status == 'ACTIVE'">
                    <br />
                    <a
                      href=""
                      v-if="hasRole('EDITPAYMENTPLANS')"
                      @click.prevent="
                        askToProcess(
                          'Process Balance',
                          `Are you sure you would like to process the balance of ${$options.filters.currency(
                            paymentPlan.balanceDue / 100
                          )}?`,
                          paymentPlan.balanceDue
                        )
                      "
                      ><small><strong>Process Balance</strong></small></a
                    >
                  </template>
                </div>
              </div>
            </b-col>

            <b-col class="pl-0 pr-0 panel-divider">
              <div class="card-panel text-right">
                <div class="stat-box-title"></div>
                <div class="stat-box-body">
                  <customer-saved-cards
                    :customer="customer"
                    ref="customerSavedCards"
                    title=" "
                    v-if="customer && paymentPlan"
                    :selectCustomerSavedCardId="paymentPlan.customerSavedCardId"
                    @onCustomerCardSelect="onCustomerCardSelect"
                    mode="2"
                    :showChangeCard="
                      paymentPlan.status == 'ACTIVE' &&
                        hasRole('EDITPAYMENTPLANS')
                    "
                  ></customer-saved-cards>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row
      class="m-0 mt--1"
      v-if="paymentPlan.currentCycle !== 0 && paymentPlan.status == 'ACTIVE'"
    >
      <b-col class="modal-hero" style="padding-top: 0 !important;">
        <div>
          <b-progress
            :value="paymentPlan.currentCycle"
            :max="paymentPlan.cycleCount"
            variant="success"
            class="shadow-none"
            v-if="paymentPlan.status == 'ACTIVE'"
          ></b-progress>

          <h5 class="text-success mt--1">
            Cycle {{ paymentPlan.currentCycle }} of {{ paymentPlan.cycleCount }}
          </h5>
        </div>
      </b-col>
    </b-row>

    <b-row class="m-0">
      <b-col class="body-modal">
        <b-tabs class="plan-tabs">
          <b-tab
            title="Payment History"
            active
            v-if="paymentPlan.ledgerDtos.length != 0"
          >
            <payment-ledger
              :paymentLedgers="paymentPlan.ledgerDtos"
              @rebind="getPaymentPlan"
            ></payment-ledger>
          </b-tab>
          <b-tab title="Schedule" v-if="paymentPlan.status == 'ACTIVE'">
            <paymentplan-schedule-table
              :paymentPlanDetails="paymentPlan.paymentPlanDetails"
              :paymentPlan="paymentPlan"
              @rebind="getPaymentPlan"
            >
            </paymentplan-schedule-table>
          </b-tab>
          <b-tab title="Authorization" v-if="paymentPlan.approvedMethod">
            <approval
              :method="paymentPlan.approvedMethod"
              :ipAddress="paymentPlan.ipAddress"
              :signature="paymentPlan.signature"
              :template="paymentPlan.template"
              :approvedDate="paymentPlan.approvedDate"
            ></approval>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ask from "@/views/Components/Ask.vue";
import CustomerSavedCards from "@/views/Components/CustomerSavedCards";
import PaymentPlanChart from "@/views/Components/PaymentPlan/PaymentPlanChart.vue";
import PaymentPlanScheduleTable from "@/views/Components/PaymentPlan/PaymentPlanScheduleTable.vue";
import TransactionSearchResults from "@/views/Components/Transactions/SearchResults";
import PaymentLedger from "@/views/Components/PaymentLedger";
import Approval from "@/views/Components/Approval";

import swal from "sweetalert2";
export default {
  title: "Payment Plan",
  components: {
    "paymentplan-chart": PaymentPlanChart,
    ask: Ask,
    "customer-saved-cards": CustomerSavedCards,
    "transaction-search-results": TransactionSearchResults,
    "payment-ledger": PaymentLedger,
    "paymentplan-schedule-table": PaymentPlanScheduleTable,
    approval: Approval,
  },
  inject: ["hasRole"],
  props: { paymentPlanId: null, setName: null },
  data() {
    return {
      processPaymentAmount: null,
      paymentPlan: null,
      customer: null,
      showProcessDecline: false,
      oldCard: null,
      cardSelected: null,
      chartData: [],
      chartColor: [],
      refundAmount: {},
      refundVoid: {},
      refundVoidAction: "VOID",
      origRefundAmount: 0,
      processTitle: null,
      processAmount: null,
      processAmount: 0,
      transactionQuery: {
        paymentPlanDetailId: null,
        startDate: null,
        endDate: null,
        customerId: null,
        modules: [
          "TERMINAL",
          "PAYMENTPLAN",
          "TEXTTOPAY",
          "VIRTUALTERMINAL",
          "MEMBERSHIP",
        ],
        statuses: ["APPROVED", "DECLINED"],
      },
      form: {
        paymentPlanId: null,
        cardType: null,
        mask: null,
        expMonth: null,
        expYear: null,
        token: null,
      },
    };
  },

  created() {
    var self = this;

    this.getPaymentPlan();
  },
  computed: {
    nextPaymentPlanDetail() {
      return this.paymentPlan.paymentPlanDetails.find((paymentPlanDetail) => {
        return (
          !paymentPlanDetail.processedToLedger &&
          paymentPlanDetail.amountDue > 0
        );
      });
    },
  },
  methods: {
    async processPayment() {
      this.$refs.processPaymentModal.hide();
      this.askToProcess(
        "Process Payment",
        `Are you sure you would like to process this payment amount for ${this.$options.filters.currency(
          this.processPaymentAmount
        )}?`,
        this.processPaymentAmount * 100
      );
    },
    showMakePayment() {
      this.$refs.processPaymentModal.show();
    },
    viewTransactionDetails(paymentPlanDetailId) {
      this.transactionQuery.paymentPlanDetailId = paymentPlanDetailId;
      this.$refs.transactionModal.show();
    },
    dispositionSelected(paymentPlanDetailId) {
      alert(paymentPlanDetailId);
    },
    fromNow(date) {
      let fn = this.$moment(date).fromNow();

      if (fn.includes("hours") && fn.includes("in")) return "upcoming";
      else if (fn.includes("hours") && fn.includes("ago"))
        return "recently completed";
      // Created Date is midnight so just dont show it
      else return fn;
    },

    cancelNewCard() {
      this.$refs.customerSavedCards.selectCardId(this.oldCard.id);
    },
    handleUseNewCard() {
      this.$refs.customerSavedCards.selectCardId(this.newCard.id);
    },
    processCard() {
      var self = this;

      this.$client
        .post("/api/paymentPlan/setCustomerSavedCard", {
          customerSavedCardId: this.cardSelected.id,
          paymentPlanId: self.paymentPlanId,
        })
        .then((r) => {
          if (r.data.isSuccess) {
            self.paymentPlan.status = "ACTIVE";
            (self.paymentPlan.customerSavedCardId = this.cardSelected.id),
              self.$emitter.emit("success-confirm", {
                title: "Card Attached",
                message:
                  "The selected card will be used for this payment plan going forward.",
              });
          }
        });
    },
    onCustomerCardSelect(card, oldCard) {
      var self = this;

      self.oldCard = oldCard;
      self.cardSelected = card;
      if (card.id != self.paymentPlan.customerSavedCardId) this.processCard();
    },

    askToProcess(title, message, amount) {
      this.processTitle = title;
      this.processMessage = message;
      this.processAmount = amount;
      this.$refs.askToProcessModal.ask();
    },
    async process() {
      var self = this;

      let r = await this.$client.post("/api/PaymentPlan/processBalance", {
        paymentPlanId: self.paymentPlanId,
        amount: this.processAmount,
      });

      if (!r.data.isSuccess) {
        self.getPaymentPlan();
      }

      if (r.data.isSuccess) {
        self.$emitter.emit("success", {
          message: "Your transaction was approved.",
          title: "Approved",
        });

        self.getPaymentPlan();
      }
    },
    showProcessBalance(e) {
      this.processAmount = e;
      this.$refs.alert.ask();
    },

    isSettled(transaction) {
      var self = this;

      self.$client
        .get("/api/transaction/getTransaction?id=" + transaction.referenceId)
        .then((result) => {
          let t = self.paymentPlan.paymentPlanDetails.find((a) => {
            return a.referenceId == transaction.referenceId;
          });

          t.isSettled = result.data.value.isSettled;
        });
    },
    async getPaymentPlan() {
      var self = this;

      var response = await this.$client.get(
        "/api/paymentPlan/?paymentPlanId=" + self.paymentPlanId
      );

      if (response.data.isSuccess) {
        response.data.value.paymentPlanDetails.forEach((a) => {
          a.billingDateFromNow = self.fromNow(a.billingDate);
          a.isEdit = false;
          a.amountDueConverted = a.amountDue / 100;

          a.isSettled = null;
          if (a.disposition == "APPROVED" && a.referenceId) {
            self.isSettled(a);
          } else {
            a.noAction = true;
          }
        });

        self.paymentPlan = response.data.value;

        console.log(self.paymentPlan.paymentPlanDetails);

        self.customer = {
          id: self.paymentPlan.customerId,
          firstName: self.paymentPlan.firstName,
          lastName: self.paymentPlan.lastName,
          email: self.paymentPlan.eMail,
        };

        this.setName(self.customer.firstName + " " + self.customer.lastName);
      }
    },
    processDeclines() {
      var self = this;

      self.$client
        .post(
          "/api/paymentPlan/processDeclines?paymentPlanId=" + self.paymentPlanId
        )
        .then((r) => {
          self.getPaymentPlan();
          self.$bvModal.hide("modalProcessDeclines");

          if (r) {
            self.$root.$bvToast.toast(
              "Your declined transactions have been processed.",
              {
                title: "Declines",
                autoHideDelay: 5000,
                variant: "info",
                solid: true,
              }
            );
          } else {
            self.$root.$bvToast.toast(
              "There was an error processing your declines.",
              {
                title: "Declines",
                autoHideDelay: 5000,
                variant: "danger",
                solid: true,
              }
            );
          }
        });
    },

    changedActive(e) {
      var self = this;

      this.$client
        .post("/api/PaymentPlan/setActive", {
          paymentPlanId: self.paymentPlan.id,
          active: e,
        })
        .then((response) => {
          if (response.data.isSuccess && !e) {
            self.$emitter.emit("success", {
              message:
                "This payment plan has been canceled, and will no longer process transactions.",
            });

            self.getPaymentPlan();
          }
          if (response.data.isSuccess && e) {
            self.$emitter.emit("success", {
              message: "This payment plan has been activated.",
            });

            self.getPaymentPlan();
          }
        });
    },
  },
};
</script>

<style>
.approved {
  color: #7aa924;
}

.declined {
  color: #fd5c64;
}

.plan-tabs .table thead th,
.plan-tabs .el-table thead th {
  border-top: 0;
}

.bg-secondary {
  background-color: #adb5bd !important;
}
</style>
